import { useTranslation } from 'react-i18next';

import { PageLayout, PageTitle } from 'core/components';
import { SelectionCountProvider } from 'core/states';
import { CustomerQuoteList } from 'quotes/components';

const CustomerQuoteListPage = () => {
  const { t } = useTranslation();

  return (
    <PageLayout title={t('titleCustomerQuotes')} hasSwitchVersion>
      <SelectionCountProvider>
        <PageTitle title={t('titleCustomerQuotes')} />
        <CustomerQuoteList />
      </SelectionCountProvider>
    </PageLayout>
  );
};

export default CustomerQuoteListPage;
